<template lang="pug">
.wrapper
    nav.nav
        div
        div
            button.button__action(
                @click="toggleCreateProductModal"
                to="/products/create"
            ) Create New Product
    LibraryGrid
        .view-explanation
            h1 Products
        vue-tabs(
            v-model="tabName"
            active-text-color="#09a3ed"
            @tab-change="handleTabChange"
        )
            v-tab(title="Active Products")
                LibraryGrid(
                    :baseStyle="{backgroundColor: '#FFF', minHeight: 'inherit'}"
                )
                    button.box(
                        @click="toggleCreateProductModal"
                        v-if="!getProducts.length"
                        to="/products/create"
                    ) Create a New Product
                    router-link.product__link(
                        :key="`${product._id}`"
                        v-for="product in getProducts"
                        v-if="getProducts.length"
                        :to="`/products/${product._id}`"
                    )
                        .product.box
                            .image__container
                                img(
                                    v-if="product.defaultImage"
                                    :src="product.defaultImage"
                                )
                                img(
                                    v-if="!product.defaultImage"
                                    src="/static/images/product-placeholder.png"
                                )
                            h3 {{product.name}}
            v-tab(title="Deleted Products")
                LibraryGrid(
                    :baseStyle="{backgroundColor: '#FFF', minHeight: 'inherit'}"
                )
                    div.no-deleted-products(
                        v-if="!deletedProducts.length"
                    )
                        div
                            h3 No deleted products found.
                            button.box(
                                @click="returnToActive"
                                to="/products/create"
                            ) View Active Products
                    router-link.product__link(
                        :key="`${product._id}`"
                        v-for="product in deletedProducts"
                        v-if="deletedProducts.length"
                        :to="`/products/${product._id}`"
                    )
                        .product.box
                            .image__container
                                img(
                                    v-if="product.defaultImage"
                                    :src="product.defaultImage"
                                )
                                img(
                                    v-if="!product.defaultImage"
                                    src="/static/images/product-placeholder.png"
                                )
                            h3 {{product.name}}


</template>
<script>
import LibraryGrid from '../general/LibraryGrid';
import Services from '../../services/Services';
import Spinner from '../general/Spinner';
import { VueTabs, VTab } from 'vue-nav-tabs';
import 'vue-nav-tabs/themes/paper.css';
import store from '../../store';
import { getResource } from '../../services/Utils';
export default {
  name: 'ProductLibrary',
  components: {
    LibraryGrid,
    Spinner,
    VueTabs,
    VTab
  },
  computed: {
    getProducts() {
      return store.getters.getProducts;
    },
    getProductGroups() {
      return store.getters.getAllProductGroups;
    },
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  mounted() {
    Services.getProducts();
    Services.getMarkets();
  },
  methods: {
    returnToActive() {
        this.tabName = 'Active Products'
    },
    toggleCreateProductModal() {
      return store.commit('showCreateProductModal', true);
    },
    handleTabChange(tabIndex, newTab) {
        if(this.tabName === 'Deleted Products') {
            // get deleted products
            getResource(`/v1/products/deleted`)
            .then(res => {
                if (res.status === 'success') {
                    this.deletedProducts = res.products;
                }
                if (res.status === 'error') return console.log(res.error);
            })
            .catch(err => console.log(err))
        }
    }
  },
  data() {
      return {
          tabName: '',
          deletedProducts: []
      }
  }
};
</script>
<style lang="scss" scoped>
.vue-tabs {
    background: #FFF;
    width: 100%;

    .nav-tabs-background {
        background: #F5F5F5;
    }

    .tab-content {
        background: #FFF;
    }
}
.product__link {
  padding: 0 2rem 2%;
  text-decoration: none;
  max-width: 460px;
  min-width: 300px;
  width: 25%;

  @media all and(max-width:640px) {
    width: 100%;
  }

  &:first-child {
    padding-left: 0;
  }
}
.box {
  margin: auto;
  border: 1px dashed #ccc;
  color: #666;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &.product {
    border-style: solid;
    flex-direction: column;
    text-transform: capitalize;
    text-align: center;
    padding: 1.6rem;
    align-items: flex-end;
    text-decoration: none;
    width: 100%;

    h3 {
      width: 100%;
    }

    .image__container {
      overflow: hidden;
    }

    img {
      margin: auto;
      max-width: 100%;
    }
  }

  &:hover {
    border-color: rgb(1, 168, 220);
    color: #073262;
    cursor: pointer;
  }
}

.button__action,
.box {
  text-decoration: none;
}

.no-deleted-products {
    min-height: 400px;
    margin-top: -60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;

    .box {
        margin: auto;
    }
}
</style>
<style lang="scss">
.nav-tabs-navigation {
background: #F5F5F5 !important;
margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ProductLibrary.vue